export default "__VITE_ASSET__2d1967df__"